define("shared/components/shared/ui/calculating-state", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.CalculatingStateComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{or @wrapperClass "o--calculatingWrapper"}}>
    <div class="{{if (eq @customColor 'grey') 'o--calculating__grey' 'o--calculating'}} u--m__b__lg"></div>
    <div class="o--calculating__desc" ...attributes>{{@text}}</div>
  </div>
  */
  {
    "id": "YPRy0642",
    "block": "[[[10,0],[15,0,[28,[37,0],[[30,1],\"o--calculatingWrapper\"],null]],[12],[1,\"\\n  \"],[10,0],[15,0,[29,[[52,[28,[37,2],[[30,2],\"grey\"],null],\"o--calculating__grey\",\"o--calculating\"],\" u--m__b__lg\"]]],[12],[13],[1,\"\\n  \"],[11,0],[24,0,\"o--calculating__desc\"],[17,3],[12],[1,[30,4]],[13],[1,\"\\n\"],[13]],[\"@wrapperClass\",\"@customColor\",\"&attrs\",\"@text\"],false,[\"or\",\"if\",\"eq\"]]",
    "moduleName": "shared/components/shared/ui/calculating-state.hbs",
    "isStrictMode": false
  });
  const CalculatingStateComponent = _exports.CalculatingStateComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CalculatingStateComponent);
});